import React from 'react';
import './Popup.scss';
import Parser from 'html-react-parser';
import ErrorIcon from "../Icons/ErrorIcon";
import SuccessIcon from "../Icons/SuccessIcon";

const Popup = props => (

  <div className={`popup ${props.position}`}>
    <div className="popup__close" onClick={() => {props.onClose()}}>
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="0.962048" height="26.9373" rx="0.481024" transform="matrix(0.678065 -0.735002 0.678065 0.735002 0.873291 0.707031)" fill="black" />
        <rect width="0.962048" height="26.9373" rx="0.481024" transform="matrix(-0.678065 -0.735002 0.678065 -0.735002 1.7959 20.5061)" fill="black" />
      </svg>
    </div>
    <div className="popup__inner">
      <div className="popup__title">
        {props.icon
          ? props.icon === "success"
            ? <SuccessIcon />
            : <ErrorIcon />
          : null}
        {Parser(props.title)}
      </div>

      {props.img
        ? <div className="popup__img">
          <img src={props.img} alt="" />
        </div>
        : null}

      {props.text
        ? <div className={"popup__text"}>
          {Parser(props.text)}
        </div>
        : null}

      {props.showNote
        ? <div className={"popup__note"}>
          <p>
            Пример номера модели: «OLED55B8PLA»<br />
            Пример суффикса: «ARU»
          </p>
          <p>*для корректного отображения результата номера модели и&nbsp;суффикса необходимо поставить "."</p>
        </div>
        : null}

    </div>
  </div>
);

export default Popup;
